import { loadableWithFallback } from '@vision/ui/utils';
import type { StarChart1Props } from './StarChart1';

export const StarChart1 = loadableWithFallback<StarChart1Props>(() => import('./StarChart1'));
